import React from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import { NinChangeboardingTourCard } from '@atlassian/jira-issue-navigator-changeboarding/src/controllers/enable-nin-changeboarding/index.tsx';
import { toSearchModeWithBasicModeFallback } from '@atlassian/jira-jql-builder/src/common/utils.tsx';
import { convertToView } from '../../common/utils/index.tsx';
import { useSelectedViewState } from '../../controllers/selected-view-state/index.tsx';
import type { spotlight_issueNavigator_IssueNavigatorSpotlight$key as UserPreferencesFragmentKey } from './__generated__/spotlight_issueNavigator_IssueNavigatorSpotlight.graphql';

type Props = {
	hasIssueResults: boolean;
	userPreferences: UserPreferencesFragmentKey | null;
	isAiEnabled: boolean;
};

// Remove all the changeboarding on clean up of 'remove_nin_changeboarding_rll_usages', should be showing as empty fragments already
const IssueNavigatorSpotlight = ({ hasIssueResults, userPreferences, isAiEnabled }: Props) => {
	const [{ view }] = useSelectedViewState();

	const searchModeResponse = useFragment<UserPreferencesFragmentKey>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment spotlight_issueNavigator_IssueNavigatorSpotlight on JiraUserPreferences {
				jqlBuilderSearchMode
			}
		`,
		userPreferences,
	);

	const selectedSearchMode = toSearchModeWithBasicModeFallback(
		searchModeResponse?.jqlBuilderSearchMode,
	);

	return (
		<NinChangeboardingTourCard
			mode={selectedSearchMode}
			view={convertToView(view)}
			hasIssueResults={hasIssueResults}
			isAiEnabled={isAiEnabled}
		/>
	);
};

export default IssueNavigatorSpotlight;
